import React from "react";
import image1 from "../../../Assets/Compliance Certifictes/image.png";
import image2 from "../../../Assets/Compliance Certifictes/image2.png";

const KosherInfoContainer = () => {
  return (
    <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
      {/* left side */}
      <div className="w-full">
        {/* heading */}
        <div className="py-4 md:py-10">
          <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
            <h1 className="">
              <span className="border-b-4 border-[#249742]">KOSH</span>ER
              CERTIFICATION
            </h1>
          </div>
        </div>

        {/* content */}
        <div>
          <p className="font-normal text-lg text-[#4D4D4D]">
            When a product or establishment is certified Kosher, it signifies
            that an establishment or a company comply with a strict policy of
            kosher food laws, including cleanliness, purity, and quality. It is
            the highest standard of kosher foods, built on a deep level of trust
            between manufacturers, producers and consumers.
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            Kosher foods are the food items that follow the regulations of
            kashrut (Jewish dietary law). To be certified Kosher, all
            ingredients in every product—and the process of preparing the
            product—must be certified for kosher-compliance too. All the
            products with a KA logo on it signifies product as kosher.
          </p>
        </div>
      </div>

      {/* right side */}
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
        <div className="py-0 sm:py-8">
          <img
            src={image2}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>

        <div className="py-0 sm:py-8">
          <img
            src={image1}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default KosherInfoContainer;
